import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4deac37b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./scss.scss?vue&type=style&index=0&id=4deac37b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deac37b",
  null
  
)

export default component.exports